<template>
    <div
        class="cp input autocomplete"
        :class="[errorStatus? 'is-error': '']"
        :style="style"
        :data-error="errorMsg"
    >
        <label v-if="hideLabel !== true" v-html="showLabel"></label>
        <input type="text" :value="value" @input="inputValue($event.target.value)" @keydown="changeFocusAndSet" :placeholder="placeholder">
        <transition name="animate">
            <ul v-if="show && option.length" class="func" @click.stop>
                <li
                    v-for="(item, index) in option"
                    :class="[focus === (index + 1)? 'is-active': '']"
                    :key="item"
                ><a @mouseenter="changeFocusIndex(index)" @click="selectValue(item)" v-html="item"></a></li>
            </ul>
        </transition>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex'

    export default {
        props: {
            label: {
                type: String,
                require: false,
                default: ''
            },
            options: {
                type: Array,
                require: true
            },
            errorStatus: {
                type: Boolean,
                require: false
            },
            errorMsg: {
                type: String,
                require: false
            },
            hideLabel: {
                type: Boolean,
                require: false
            },
            disabled: {
                type: Boolean,
                require: false
            },
            placeholder: {
                type: String,
                require: false,
                default: ''
            },
            value: {
                type: String,
                require: false,
                default: ''
            }
        },
        data: function(){

            return {
                show: false,
                focus: 0
            }
        },
        computed: {
            showLabel: function() {

                if( this.label ) {
                    return this.label;
                }else {
                    return '自動完成';
                }
            },
            option: function(){
                let $options = this.options,
                    _value = this.value;

                let $result = [];

                if( _value ) {
                    let _toUpperCase = _value.toUpperCase(),
                        _toLowerCase = _value.toLowerCase();

                    $options.forEach(item => {

                        if( item.includes(_value) || item.includes(_toUpperCase) || item.includes(_toLowerCase) ) {
                            let $regix = new RegExp('('+ _value +')|('+ _toUpperCase +')|('+ _toLowerCase +')', 'g'),
                                _newItem = item.replace($regix, '<span style="color: red">$1$2$3</span>');

                            $result.push(_newItem);
                        }
                    });
                }

                return $result;
            },
            style: function(){

                if( this.show ) {
                    return {
                        'z-index': 5
                    }
                }else {
                    return {};
                }
            }
        },
        methods: {
            ...mapMutations([
                'globalClickFuncQueuePush',
                'globalClickFuncQueueRun',
                'globalClickFuncQueueClear'
            ]),
            hide: function(){
                this.show = false;
                this.focus = 0;
            },
            changeFocusAndSet: function(event){
                let _index = this.focus,
                    $option = this.option,
                    _length = $option.length;

                if( this.show ) {

                    if( event.keyCode === 38 ) { //up
                        let _newIndex = (_index - 1);

                        if( _newIndex < 1 ) {
                            _newIndex = 1;
                        }

                        this.focus = _newIndex;

                    }else if( event.keyCode === 40 ) { //down
                        let _newIndex = (_index + 1);

                        if( _newIndex > _length ) {
                            _newIndex = _length;
                        }

                        this.focus = _newIndex;

                    }else if( event.keyCode === 13 ) { //enter
                        this.selectValue($option[_index - 1]);
                    }
                }
            },
            changeFocusIndex: function(index){
                this.focus = (index + 1);
            },
            inputValue: function(value){
                this.show = true;
                this.focus = 0;
                this.returnValue(value);
            },
            selectValue: function(value){
                this.show = false;

                let _value = value.replace(/\<(\/?)span(\sstyle="color: red")?\>/g, '');

                this.returnValue(_value);
            },
            returnValue: function(value){
                this.$emit('input', value);
            }
        },
        created: function(){

            this.globalClickFuncQueuePush({
                id: this.id,
                func: this.hide
            });
        },
        destroyed: function(){
            this.globalClickFuncQueueClear(this.id);
        }
    }
</script>

<style scoped lang="scss">

    .animate-enter-active {
        animation: animate-in .3s;
    }

    .animate-leave-active {
        animation: animate-out .2s;
    }

    @keyframes animate-in {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    @keyframes animate-out {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }
</style>
